import React from 'react';
import { TypographySmall } from '@/Components/shadcn';
import { RHFInput } from '@/Components/shadcn/rhf-input';
import { useUserContext } from '@/Context/UserContext';
import UIStrings from '@/Utils/UIStrings';
import { useCompanyContext } from '@/Context/CompanyContext';
import InfoTooltip from '@/Components/Tooltip/InfoTooltip';

interface ClosureProps {
    showRecruiterName?: boolean;
}

const Closure = ({ showRecruiterName }: ClosureProps) => {
    const { user } = useUserContext();
    const { currentCompanyProfile } = useCompanyContext();

    return (
        <>
            <RHFInput fieldClassName="w-68" name="regards" />
            {showRecruiterName && (
                <div className="flex flex-row items-center justify-start gap-1 pl-2">
                    <TypographySmall>
                        {user?.firstName} {user?.lastName}
                    </TypographySmall>
                    <InfoTooltip description={UIStrings.RecruiterNameTooltip} side="right" size="icon-xs" />
                </div>
            )}
            <TypographySmall className="pl-2">{currentCompanyProfile.companyName}</TypographySmall>
        </>
    );
};

export default Closure;
